var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderSuccessfully(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-order-successfully"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order-successfully",
    clipPath: "url(#clip-order-successfully)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "product-added",
    transform: "translate(-27 -144.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M-11.5,514.8a4.335,4.335,0,0,1,2.344,3.9c1.953-1.3,2.865-2.474,4.558-4.948A4,4,0,0,0-6.942,510.5C-8.375,512.453-9.547,513.886-11.5,514.8Z",
    transform: "translate(198.717 -87.25)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M50.7,488.293a7.05,7.05,0,0,0,2.474-.391,2.577,2.577,0,0,0-.912-1.3,2.819,2.819,0,0,1-1.563.26,1.389,1.389,0,0,1,0,1.431Z",
    transform: "translate(217.513 -94.472)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M61.8,467.6a13.089,13.089,0,0,1,1.432,4.818,33.024,33.024,0,0,1,8.855-4.427,6.814,6.814,0,0,0-.781-4.688,35.589,35.589,0,0,0-9.506,4.3Z",
    transform: "translate(220.867 -101.513)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M-36.714,512.3a7.285,7.285,0,0,0-3.386,2.344,6.7,6.7,0,0,1,2.865,3.255,9.743,9.743,0,0,0,3.516-1.693,12.991,12.991,0,0,1-3-3.906Z",
    transform: "translate(190.073 -86.706)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M-8.954,507.042A1.732,1.732,0,0,0-9.345,506a9.435,9.435,0,0,1-3.255,1.432,1.4,1.4,0,0,1,.26,1.042,7.86,7.86,0,0,0,3.386-1.432Z",
    transform: "translate(198.384 -88.61)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M99.5,420.5a1.975,1.975,0,0,0-.391,1.693,4.5,4.5,0,0,0,1.693.391,4.146,4.146,0,0,1,1.432-1.693A6.648,6.648,0,0,1,99.5,420.5Z",
    transform: "translate(232.128 -114.447)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M-51.7,487.3a5.673,5.673,0,0,0,1.3,4.3,26.46,26.46,0,0,1,7.813-.651,4.339,4.339,0,0,1-.26-2.474A34.481,34.481,0,0,1-51.7,487.3Z",
    transform: "translate(186.568 -94.261)",
    fill: "#43a633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M30.6,332.853c1.563,1.953,3.386,4.037,6.251,4.818a19.115,19.115,0,0,1,5.469-1.693c-1.432-1.172-1.693-2.474-1.432-5.079C38.022,332.2,34.9,332.463,30.6,332.853Z",
    transform: "translate(211.439 -141.523)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M-5.049,505.284a6.634,6.634,0,0,1,2.214-.912,3.218,3.218,0,0,0-.521-1.172,4.944,4.944,0,0,0-2.344.781C-5.179,504.372-4.919,504.763-5.049,505.284Z",
    transform: "translate(200.47 -89.456)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M-80.956,471.011a6.6,6.6,0,0,1-1.953-.911,1.732,1.732,0,0,0-.391,1.042,7.508,7.508,0,0,0,1.823,1.042,1.269,1.269,0,0,1,.521-1.173Z",
    transform: "translate(177.02 -99.458)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M-110.812,373.891c-.781-.781-1.823-.911-3.386-.781a13.977,13.977,0,0,1-1.3,6.12,5.59,5.59,0,0,1,3.386,1.172A13.584,13.584,0,0,0-110.812,373.891Z",
    transform: "translate(167.289 -128.781)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M-22.435,495.563A4.347,4.347,0,0,0-24.388,494a2.407,2.407,0,0,0-.912,1.172,4.545,4.545,0,0,1,1.953,1.563C-23.216,496.083-22.956,495.693-22.435,495.563Z",
    transform: "translate(194.546 -89.236)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M-41.9,532.555a3.012,3.012,0,0,1,.781,2.474,23.591,23.591,0,0,0,6.771-2.6,6.335,6.335,0,0,0-.912-3.125,13.3,13.3,0,0,1-6.64,3.251Z",
    transform: "translate(189.53 -81.569)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M-4.3,524.442a10.4,10.4,0,0,0,2.735,3.386,4.9,4.9,0,0,0,1.172-2.344A4.607,4.607,0,0,1-2.086,523.4,3.21,3.21,0,0,1-4.3,524.442Z",
    transform: "translate(200.893 -83.352)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M99.6,398.907a18.446,18.446,0,0,1,6.511,1.042,5.079,5.079,0,0,0,.26-3.386A21.614,21.614,0,0,0,99.86,395C100.512,396.823,100.512,397.865,99.6,398.907Z",
    transform: "translate(232.29 -122.153)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M58.6,462.965a8.654,8.654,0,0,1-5.209-2.865c-1.3,3.646-2.214,7.553-2.084,9.376a12.719,12.719,0,0,0,5.6.781C56.772,468.174,57.423,466.22,58.6,462.965Z",
    transform: "translate(217.691 -102.48)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M-26.158,311.7c3-.651,4.558-.781,7.032-.13.13-1.172.26-1.953.912-2.474a14.118,14.118,0,0,0-7.813-.521,5.135,5.135,0,0,0-.131,3.125Z",
    transform: "translate(194.232 -148.363)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M-107.261,391.114a2.9,2.9,0,0,0-1.172-2.214,16.668,16.668,0,0,1-4.167,1.172,2.911,2.911,0,0,1,.391,1.3,15.627,15.627,0,0,1,4.948-.258Z",
    transform: "translate(168.165 -123.996)",
    fill: "#b340ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M91.8,373.574c1.042,1.172,1.563,2.865,1.432,6.771a7.469,7.469,0,0,0,4.688-2.214,14.752,14.752,0,0,0-2.084-7.032C94.8,372.4,93.753,372.793,91.8,373.574Z",
    transform: "translate(229.933 -129.375)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M59.55,495.1a2.841,2.841,0,0,0-.521,2.735,4.069,4.069,0,0,0,2.6.521,5.219,5.219,0,0,1,2.214-2.6,15.589,15.589,0,0,1-4.293-.656Z",
    transform: "translate(219.992 -91.904)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M53.323,476.594a8.217,8.217,0,0,1,1.042-2.995,2.349,2.349,0,0,0-1.563-.391,9.307,9.307,0,0,0-1.3,3C52.412,476.073,52.932,476.073,53.323,476.594Z",
    transform: "translate(217.755 -98.53)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M-69.984,328.1c-.521.651-1.432,1.042-3.516,1.3a4.4,4.4,0,0,0,1.563,2.344,7.888,7.888,0,0,0,3.516-1.563,8.718,8.718,0,0,1-1.563-2.081Z",
    transform: "translate(179.98 -142.369)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M85.2,397.9a3.555,3.555,0,0,1,1.172,1.563,15.344,15.344,0,0,1,2.6-3A2.268,2.268,0,0,0,87.93,394.9a22.5,22.5,0,0,0-2.73,3Z",
    transform: "translate(227.938 -122.183)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M3.9,518.53a16.424,16.424,0,0,0,1.172,4.037A3.873,3.873,0,0,0,6.9,520.874a4.646,4.646,0,0,1-.781-2.474,2.613,2.613,0,0,1-2.219.13Z",
    transform: "translate(203.37 -84.863)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M-3.4,517.5a2.6,2.6,0,0,1-2.6.521,9.619,9.619,0,0,0,1.693,3.516c.912.26,1.432,0,2.344-.651A8.264,8.264,0,0,1-3.4,517.5Z",
    transform: "translate(200.379 -85.135)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M11.563,503.607a11.047,11.047,0,0,1,2.865-2.6A2.776,2.776,0,0,0,13,499.7a11.4,11.4,0,0,0-3,2.474C10.912,502.565,11.3,502.825,11.563,503.607Z",
    transform: "translate(205.214 -90.514)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M-121.7,373.676a10.578,10.578,0,0,1-2.474-3.776A4.092,4.092,0,0,0-126,371.332a15.033,15.033,0,0,0,2.344,4.037C-123.135,374.2-122.745,373.676-121.7,373.676Z",
    transform: "translate(164.116 -129.738)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M-113.919,459.667a5.759,5.759,0,0,1,.13-4.167,21.042,21.042,0,0,0-6.511,1.823A9.353,9.353,0,0,0-119,461.1C-117.826,460.188-116.393,459.927-113.919,459.667Z",
    transform: "translate(165.838 -103.87)",
    fill: "#47eeb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M-132.609,453.1a2.367,2.367,0,0,1-.391,1.823,18.263,18.263,0,0,0,5.209.912,4.336,4.336,0,0,0,.521-2.214,12.284,12.284,0,0,1-5.339-.521Z",
    transform: "translate(162 -104.596)",
    fill: "#2619a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M-26.821,537.4c-.391.391-.391.781-.26,1.432a2.006,2.006,0,0,0,1.432.26,3.029,3.029,0,0,1,1.172-1.432,7.213,7.213,0,0,1-2.344-.26Z",
    transform: "translate(193.984 -79.121)",
    fill: "#2619a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M86.16,492.165a3.464,3.464,0,0,0,1.3-1.432,4.681,4.681,0,0,1-.26-1.432c-.26.391-.651.391-1.3.26a8.029,8.029,0,0,1,.26,2.6Z",
    transform: "translate(228.149 -93.656)",
    fill: "#2619a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M16.651,512.9A1.8,1.8,0,0,1,16,514.072a10.716,10.716,0,0,0,3.255,1.563,2.38,2.38,0,0,0,.781-1.3,7.862,7.862,0,0,1-3.385-1.435Z",
    transform: "translate(207.026 -86.525)",
    fill: "#2619a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M-87.6,453.667a3.143,3.143,0,0,1,2.865,1.432,9.554,9.554,0,0,0,.781-4.558,2.714,2.714,0,0,0-2.6-1.042,7.364,7.364,0,0,1-1.046,4.168Z",
    transform: "translate(175.72 -105.683)",
    fill: "#2619a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M40.1,490.832a8.157,8.157,0,0,0,2.865.912,2.731,2.731,0,0,0-.26-1.823,3.562,3.562,0,0,1-1.823-.521A1.5,1.5,0,0,1,40.1,490.832Z",
    transform: "translate(214.31 -93.626)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M-93.735,352a8.222,8.222,0,0,1-2.865,1.042,19.688,19.688,0,0,1,3,5.209,4.11,4.11,0,0,0,2.865-.651,24.066,24.066,0,0,0-3-5.6Z",
    transform: "translate(173 -135.147)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M-93.833,440.535a2.877,2.877,0,0,0-.912-2.735,4.752,4.752,0,0,0-2.6.781A7.257,7.257,0,0,1-98,442.1a12.477,12.477,0,0,1,4.167-1.565Z",
    transform: "translate(172.577 -109.219)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M96.1,386.8a6.828,6.828,0,0,1-1.3,2.344,1.672,1.672,0,0,0,1.3.521,9.175,9.175,0,0,0,1.432-2.344A1.779,1.779,0,0,1,96.1,386.8Z",
    transform: "translate(230.84 -124.631)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M-109.986,450.1a4.1,4.1,0,0,1-2.214,1.172c.13.391.26.651.13.912a5.5,5.5,0,0,0,2.6-1.042C-109.465,450.751-109.726,450.491-109.986,450.1Z",
    transform: "translate(168.286 -105.502)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M-99.279,471.614a10.866,10.866,0,0,0,2.214-1.432A2,2,0,0,0-98.5,469.4c-.26.521-.781.651-1.3.912A1.331,1.331,0,0,1-99.279,471.614Z",
    transform: "translate(172.033 -99.67)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M-92.2,477.558a7.252,7.252,0,0,1,2.214,4.948c3-1.953,5.86-4.3,6.641-5.73A14.143,14.143,0,0,0-86.991,473C-87.9,474.693-89.465,475.735-92.2,477.558Z",
    transform: "translate(174.33 -98.582)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M-79.9,477.1a6.775,6.775,0,0,0,5.86-.912,43.5,43.5,0,0,1,.651-10.157,6.444,6.444,0,0,1-3.255-.13C-77.165,470.327-78.207,472.932-79.9,477.1Z",
    transform: "translate(178.047 -100.728)",
    fill: "#ff4079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M37.018,508.763a12.475,12.475,0,0,1-4.167-1.563,4.8,4.8,0,0,0-.651,2.214,14.085,14.085,0,0,0,4.167,1.823A2.12,2.12,0,0,1,37.018,508.763Z",
    transform: "translate(211.922 -88.247)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M-95.824,400.693c.13-.651-.13-1.042-.651-1.693a7.3,7.3,0,0,1-3.125,1.3,2.545,2.545,0,0,1,.521,1.823,11.846,11.846,0,0,0,3.255-1.43Z",
    transform: "translate(172.093 -120.944)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M63.8,389.332c.26.912,1.042,1.432,2.084,2.214,1.563-2.474,3.907-4.558,6.771-6.9a4.588,4.588,0,0,1-1.693-2.344,23.04,23.04,0,0,0-7.162,7.03Z",
    transform: "translate(221.472 -125.991)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M-60.638,472.976a5.36,5.36,0,0,0-4.688-.391,31.17,31.17,0,0,1-2.474,7.683,5.165,5.165,0,0,1,2.474.651A34.5,34.5,0,0,1-60.638,472.976Z",
    transform: "translate(181.703 -98.819)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M-100.184,388.227a14.815,14.815,0,0,0-1.563-4.427,5.527,5.527,0,0,0-1.953,1.953,4.2,4.2,0,0,1,.912,2.6,3.634,3.634,0,0,1,2.6-.126Z",
    transform: "translate(170.854 -125.537)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M-127.786,436.666a5.513,5.513,0,0,0,3.516-2.865,31.391,31.391,0,0,1-3.516-6.9A4.1,4.1,0,0,1-130,428.072a27.883,27.883,0,0,1,2.214,8.594Z",
    transform: "translate(162.907 -112.513)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M-71.979,338.7a4.314,4.314,0,0,0-.521,1.953,6.519,6.519,0,0,1,.912,1.042c.13-.521.391-.651,1.042-.912a7.161,7.161,0,0,1-1.433-2.083Z",
    transform: "translate(180.283 -139.166)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M-46.829,332.083A3.632,3.632,0,0,1-44.745,330,28.353,28.353,0,0,0-51,324.4a6.07,6.07,0,0,0-2.6,2.6,16.641,16.641,0,0,1,6.771,5.083Z",
    transform: "translate(185.994 -143.488)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M-107.2,363.263a1.647,1.647,0,0,1,.912,1.3,5.252,5.252,0,0,0,1.432-1.823,1.458,1.458,0,0,0-.912-1.042C-106.158,362.481-106.419,363-107.2,363.263Z",
    transform: "translate(169.797 -132.216)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M-95,419.1a5.171,5.171,0,0,0-4.3,1.953A41.074,41.074,0,0,1-97.607,429a5.457,5.457,0,0,1,2.6-.651A31.426,31.426,0,0,1-95,419.1Z",
    transform: "translate(172.184 -114.87)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M-123.34,390.83a1.472,1.472,0,0,1-.26,1.432,4.154,4.154,0,0,0,2.083-.261c.26-.391.26-.651.13-1.3a2.586,2.586,0,0,1-1.953.129Z",
    transform: "translate(164.841 -123.452)",
    fill: "#e0008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M55.048,525.253a2.969,2.969,0,0,1,2.344-1.432,26.29,26.29,0,0,0-4.427-6.12,5.694,5.694,0,0,0-2.865,1.823C52.574,521.086,53.616,522.648,55.048,525.253Z",
    transform: "translate(217.332 -85.074)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M-71.9,527.721a12.951,12.951,0,0,0,1.823,4.037,8.284,8.284,0,0,0,1.823-2.083,4.417,4.417,0,0,1-1.172-2.474A2.607,2.607,0,0,1-71.9,527.721Z",
    transform: "translate(180.465 -82.203)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M73.365,494.495a5.509,5.509,0,0,0-1.042-3,2.823,2.823,0,0,0-1.823.651,5.91,5.91,0,0,1,1.042,3,1.745,1.745,0,0,1,1.823-.651Z",
    transform: "translate(223.496 -92.991)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M30.1,501.593a9.589,9.589,0,0,1,3.776,3.386c.651-.651,1.042-.911,1.693-.911a11.4,11.4,0,0,0-3.776-4.167,5.24,5.24,0,0,0-1.693,1.692Z",
    transform: "translate(211.288 -90.453)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M-93.2,458.8a6.358,6.358,0,0,1,2.214.13,1.807,1.807,0,0,0,0-1.172,9.352,9.352,0,0,0-2.214-.26A1.183,1.183,0,0,1-93.2,458.8Z",
    transform: "translate(174.027 -103.266)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M-40.326,491.33a3.628,3.628,0,0,1-2.084-.13.6.6,0,0,1-.391.651,4.461,4.461,0,0,0,2.344.391,1.931,1.931,0,0,0,.131-.912Z",
    transform: "translate(189.258 -93.082)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M61.1,483.211a7.943,7.943,0,0,0,1.953,1.693,2.529,2.529,0,0,0,.391-1.563c-.521-.13-.781-.521-1.172-1.042A1.25,1.25,0,0,1,61.1,483.211Z",
    transform: "translate(220.656 -95.772)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M77.6,436.993a6.69,6.69,0,0,0,2.735,2.083,2.9,2.9,0,0,0,1.172-1.693,5.819,5.819,0,0,1-2.6-2.084A2.533,2.533,0,0,1,77.6,436.993Z",
    transform: "translate(225.643 -109.975)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M28.4,536.688c1.693.391,3.255,1.563,5.469,5.209a8.889,8.889,0,0,0,2.865-4.818c-2.083-2.479-3.386-3.779-6.25-5.079C30.353,533.953,29.7,535,28.4,536.688Z",
    transform: "translate(210.773 -80.753)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M10.835,313.535a3.33,3.33,0,0,0-1.953,0,3.694,3.694,0,0,1-.781,1.172c.521,0,.781.26,1.042.781a4.718,4.718,0,0,1,1.692-1.953Z",
    transform: "translate(204.64 -146.816)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M-54.926,512.855a7.974,7.974,0,0,0-.912-3.255,4.246,4.246,0,0,0-1.563,1.432,4.336,4.336,0,0,1,.651,1.953A1.836,1.836,0,0,1-54.926,512.855Z",
    transform: "translate(184.847 -87.522)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M60.315,481.065A4.893,4.893,0,0,0,57.19,478.2a27.4,27.4,0,0,1-5.99,4.167,5.406,5.406,0,0,1,1.432,1.823,32.833,32.833,0,0,1,7.683-3.125Z",
    transform: "translate(217.664 -97.011)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M47.481,343.2a12.7,12.7,0,0,1-.781,5.2,42.149,42.149,0,0,1,10.418-.521,7.742,7.742,0,0,0,1.3-4.818,44.233,44.233,0,0,0-10.937.134Z",
    transform: "translate(216.304 -137.931)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M98.212,462.209c2.474-.13,4.3-.391,6.12-1.563A5.511,5.511,0,0,0,103.29,457a10.758,10.758,0,0,1-5.99,1.432C98.212,459.865,98.6,460.776,98.212,462.209Z",
    transform: "translate(231.595 -103.417)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M71.8,426.211a2.53,2.53,0,0,0,1.172,1.432,11.8,11.8,0,0,1,2.865-1.432,7.462,7.462,0,0,1-.521-.911A17.476,17.476,0,0,1,71.8,426.211Z",
    transform: "translate(223.89 -112.997)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M-93.549,412.313a3.36,3.36,0,0,1,2.214-1.953,30.53,30.53,0,0,0-5.73-5.86,7.4,7.4,0,0,0-2.735,2.344,17.011,17.011,0,0,1,6.251,5.469Z",
    transform: "translate(172.033 -119.282)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M-25.293,521.2a14.351,14.351,0,0,0-3.907,2.474,4.233,4.233,0,0,0,2.344,1.432,4.411,4.411,0,0,1,2.344-1.563A3.037,3.037,0,0,1-25.293,521.2Z",
    transform: "translate(193.368 -84.017)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M-100,417.551a8.144,8.144,0,0,1,4.037,4.3c2.344-3.125,4.3-6.381,4.688-8.073a13.227,13.227,0,0,0-5.079-2.474C-96.745,413.253-97.916,414.946-100,417.551Z",
    transform: "translate(171.973 -117.227)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M-9.2,540.558a5.64,5.64,0,0,0,3.907,2.865,35.533,35.533,0,0,1,6.251-5.469A6.26,6.26,0,0,1-.866,536,34.614,34.614,0,0,1-9.2,540.558Z",
    transform: "translate(199.412 -79.544)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M84.511,399.9a11.112,11.112,0,0,1-5.99.911A2.4,2.4,0,0,1,78,403.025a12.213,12.213,0,0,0,6.771-.391A4,4,0,0,0,84.511,399.9Z",
    transform: "translate(225.763 -120.672)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M-34.965,492.842a2.394,2.394,0,0,0-1.823-1.042,3.039,3.039,0,0,0-.912,1.823,3.893,3.893,0,0,1,1.432,2.214,6.81,6.81,0,0,1,1.3-2.995Z",
    transform: "translate(190.8 -92.901)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M73.612,407.123a1.1,1.1,0,0,0-.912,0,7.508,7.508,0,0,1,.13,2.995,2.214,2.214,0,0,1,.912.13,8.536,8.536,0,0,0-.13-3.125Z",
    transform: "translate(224.161 -118.519)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M83.076,463.741c-1.172-.391-2.214-.13-3.776.781a13.634,13.634,0,0,1,1.563,6.771c1.172-.651,2.084-.651,3.907-.391a16.031,16.031,0,0,0-1.694-7.161Z",
    transform: "translate(226.155 -101.433)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M-15.677,522.7c0,.911-.391,1.823-1.823,3.386a4.531,4.531,0,0,0,2.735.781,8.278,8.278,0,0,0,1.693-3.776,3.2,3.2,0,0,1-2.6-.391Z",
    transform: "translate(196.903 -83.563)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M-64,501.057c.651-2.083,2.214-3.776,6.9-6.25a11.023,11.023,0,0,0-5.73-3.907c-3.255,2.344-4.948,3.907-6.771,7.292C-67.386,498.453-66.084,499.234-64,501.057Z",
    transform: "translate(181.159 -93.173)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M88.6,459.681c-.13-.391-.391-.521-.781-.781a13.608,13.608,0,0,1-2.214,2.735,1.267,1.267,0,0,1,.651.781,8.139,8.139,0,0,0,2.344-2.735Z",
    transform: "translate(228.06 -102.843)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M38.851,311.5a2.858,2.858,0,0,0-.651,1.563,2.9,2.9,0,0,1,1.693.521,4.677,4.677,0,0,0,.912-1.3,5.138,5.138,0,0,1-1.954-.784Z",
    transform: "translate(213.735 -147.386)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M-94.963,379.182a3.87,3.87,0,0,0-3.907.391,6.426,6.426,0,0,0,.391,3.907,8.457,8.457,0,0,1,4.558,1.823,13.809,13.809,0,0,1-1.042-6.121Z",
    transform: "translate(172.274 -127.039)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M-94.628,467a3.272,3.272,0,0,0,1.823-.781,3.309,3.309,0,0,1-1.042-1.823,3.675,3.675,0,0,0-1.953.521A3.673,3.673,0,0,1-94.628,467Z",
    transform: "translate(173.241 -101.181)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M80.563,449.755c.391,0,.521-.13.912-.521a6.876,6.876,0,0,1-1.563-2.735c-.26.26-.521.26-.912.391a8.831,8.831,0,0,0,1.563,2.865Z",
    transform: "translate(226.064 -106.59)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M-35.851,503.553a4.606,4.606,0,0,1-4.427-1.953c-.912,2.214-1.042,3.906-.912,7.032,1.172,1.3,2.084,1.563,4.037,1.432C-37.153,507.33-37.023,505.506-35.851,503.553Z",
    transform: "translate(189.731 -89.939)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M-95.168,390.9a8.972,8.972,0,0,0-5.6,1.563,12.726,12.726,0,0,1-1.432,3.907c1.3-.391,2.214,0,3.646,1.432C-98.033,395.588-96.861,393.635-95.168,390.9Z",
    transform: "translate(171.308 -123.392)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M49.784,503.96A7.967,7.967,0,0,1,52,499.532a2.01,2.01,0,0,1-1.3-1.432,12.132,12.132,0,0,0-3,4.688,4.785,4.785,0,0,0,2.084,1.172Z",
    transform: "translate(216.606 -90.997)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M-85.8,469.546a1.761,1.761,0,0,0,1.172-1.172,10.439,10.439,0,0,1-1.693-2.474c-.26.26-.521.521-.781.521a8.021,8.021,0,0,1,1.3,3.125Z",
    transform: "translate(175.87 -100.728)",
    fill: "#40cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M73.2,389.753c1.823-.521,3.776-1.172,5.079-2.865a15.084,15.084,0,0,1,.391-4.167c-1.172.651-2.214.521-3.907-.521C74.893,384.544,74.242,386.758,73.2,389.753Z",
    transform: "translate(224.312 -126.021)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M-75.1,494.8a7.451,7.451,0,0,1,2.084,1.953,2.078,2.078,0,0,0,.912-1.172,9.273,9.273,0,0,0-1.953-2.083,1.834,1.834,0,0,1-1.043,1.3Z",
    transform: "translate(179.497 -92.387)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M72.4,392.225A5.346,5.346,0,0,0,75,393.4a4.7,4.7,0,0,1,.912-2.865,7.088,7.088,0,0,0-2.344-1.432,7.693,7.693,0,0,1-1.168,3.122Z",
    transform: "translate(224.07 -123.936)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M98.4,438.4a2.579,2.579,0,0,0,1.432-1.432,13.323,13.323,0,0,1-1.823-2.865,3.008,3.008,0,0,1-.912.651,17.339,17.339,0,0,1,1.3,3.646Z",
    transform: "translate(231.535 -110.337)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M-96.328,497.6c-.521.13-.781.521-1.172,1.3a8.986,8.986,0,0,1,2.344,2.083,2.9,2.9,0,0,1,1.3-1.172,6.762,6.762,0,0,0-2.472-2.211Z",
    transform: "translate(172.729 -91.148)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M-82.3,503.527a4.544,4.544,0,0,1,3,1.823,17.485,17.485,0,0,0,1.432-5.6,8.71,8.71,0,0,0-3.386-.651C-81.128,500.4-81.519,501.574-82.3,503.527Z",
    transform: "translate(177.321 -90.695)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M-50.793,530.376a5.152,5.152,0,0,0,2.865.13,23.086,23.086,0,0,1,0-8.985,3.8,3.8,0,0,1-2.6-.521,19.066,19.066,0,0,0-.265,9.376Z",
    transform: "translate(186.703 -84.077)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M37.272,512.9a8.819,8.819,0,0,1-1.172,4.167,29.207,29.207,0,0,1,8.594.651,6.255,6.255,0,0,0,1.563-3.907,38.021,38.021,0,0,0-8.985-.911Z",
    transform: "translate(213.102 -86.525)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M58.03,476.5a1.472,1.472,0,0,1,1.432.26,4.5,4.5,0,0,0-.26-2.214,1.493,1.493,0,0,0-1.3-.13,2.925,2.925,0,0,1,.128,2.084Z",
    transform: "translate(219.688 -98.179)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M71.281,435.656a3.8,3.8,0,0,1,2.083-.13,9.586,9.586,0,0,0-1.042-3.125,5.517,5.517,0,0,0-1.823.781,7.9,7.9,0,0,1,.782,2.474Z",
    transform: "translate(223.496 -110.851)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M-71.2,473.921a9.174,9.174,0,0,1,.521,3.776,4.756,4.756,0,0,0,1.953-.391,14.568,14.568,0,0,0-.26-3.907,2.151,2.151,0,0,1-2.214.522Z",
    transform: "translate(180.676 -98.461)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M21.3,500.432a7.968,7.968,0,0,0,2.735.781,3.078,3.078,0,0,0-.26-1.693,2.864,2.864,0,0,1-1.694-.52,2.573,2.573,0,0,1-.781,1.432Z",
    transform: "translate(208.629 -90.725)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M-56.977,515.5a3.115,3.115,0,0,1-1.823,1.823,26.038,26.038,0,0,0,5.339,4.688,5.839,5.839,0,0,0,2.214-2.214,14.2,14.2,0,0,1-5.73-4.3Z",
    transform: "translate(184.423 -85.739)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M-12.209,317.316c.651-.261,1.432-.261,3.125.391a3.765,3.765,0,0,0-.26-2.344,6.956,6.956,0,0,0-3.255-.13A4.959,4.959,0,0,1-12.209,317.316Z",
    transform: "translate(198.384 -146.301)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M-106.9,435a7.234,7.234,0,0,1-3,.651,21.166,21.166,0,0,1,2.474,5.729,3.822,3.822,0,0,0,3-.391A42.3,42.3,0,0,0-106.9,435Z",
    transform: "translate(168.981 -110.065)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M-6.968,328.388A16.175,16.175,0,0,1-1.5,326.435,4.423,4.423,0,0,0-2.67,323.7a21.231,21.231,0,0,0-5.73,1.563C-7.1,326.435-6.707,327.086-6.968,328.388Z",
    transform: "translate(199.653 -143.699)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M58.721,340.9a2.21,2.21,0,0,0-.521,1.693,6.193,6.193,0,0,1,3,.912,2.52,2.52,0,0,1,.781-1.563,7.935,7.935,0,0,0-3.26-1.042Z",
    transform: "translate(219.779 -138.501)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M-115.47,473.842a3.89,3.89,0,0,1-.13,3.386,32.988,32.988,0,0,0,9.506-.26,7.536,7.536,0,0,0,.13-4.167C-109.349,474.1-111.824,474.1-115.47,473.842Z",
    transform: "translate(167.258 -98.642)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M-23.619,508.974a3.882,3.882,0,0,1,1.3-1.823c-.26-.26-.521-.391-.521-.651a4.737,4.737,0,0,0-1.563,1.953,2,2,0,0,0,.784.521Z",
    transform: "translate(194.818 -88.459)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M4.507,504.211A5.683,5.683,0,0,1,8.022,502c-1.823-2.083-3.907-3.906-5.079-4.3A8.737,8.737,0,0,0,.6,500.955C1.9,501.476,2.814,502.518,4.507,504.211Z",
    transform: "translate(202.373 -91.118)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M-7.23,299.789a3.144,3.144,0,0,1,0-2.865,26.073,26.073,0,0,0-7.813.521,6.221,6.221,0,0,0,0,3.516C-12.308,299.658-10.355,299.658-7.23,299.789Z",
    transform: "translate(197.571 -151.822)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M-28.736,499.9a5.16,5.16,0,0,0-1.042,4.3,30.9,30.9,0,0,1,6.9,3.386,4.4,4.4,0,0,1,1.042-2.214,34.469,34.469,0,0,1-6.9-5.472Z",
    transform: "translate(193.165 -90.453)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M-102.1,429.937a3.091,3.091,0,0,1,2.474,2.083,9.947,9.947,0,0,0,1.953-4.427,2.754,2.754,0,0,0-2.344-1.693A9.149,9.149,0,0,1-102.1,429.937Z",
    transform: "translate(171.338 -112.815)",
    fill: "#ff4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M19.253,315a2.285,2.285,0,0,1-1.953.781,7.18,7.18,0,0,0,1.823,2.344,1.586,1.586,0,0,0,1.563-.781A4.6,4.6,0,0,1,19.253,315Z",
    transform: "translate(207.42 -146.328)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M-3.678,512.453a2.989,2.989,0,0,0,1.042,3.125,5.584,5.584,0,0,0,3.125-1.042c-.26-1.432.13-2.344.651-4.037a12.977,12.977,0,0,1-4.818,1.954Z",
    transform: "translate(201.052 -87.25)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M65,378.565a8.674,8.674,0,0,0,4.688,1.953,5.394,5.394,0,0,0,1.172-2.865A8.451,8.451,0,0,1,66.3,375.7C66.172,377.132,65.912,377.914,65,378.565Z",
    transform: "translate(221.834 -127.985)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M-30.093,499.572a1.753,1.753,0,0,1-.651-1.172A16,16,0,0,0-34,500.223a3.678,3.678,0,0,0,.651,1.432,12.545,12.545,0,0,1,3.256-2.083Z",
    transform: "translate(191.917 -90.906)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M59.8,454.814a2.152,2.152,0,0,0,1.693,1.042,22.186,22.186,0,0,1,2.474-2.474,2.211,2.211,0,0,1-.781-.781,12.56,12.56,0,0,1-3.386,2.213Z",
    transform: "translate(220.263 -104.747)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M-96.4,446.041c.26,1.693,1.3,2.6,3.386,3.776a20.187,20.187,0,0,1,6.771-6.12c-1.432-.912-2.084-1.953-2.865-4.3a27.048,27.048,0,0,0-7.292,6.644Z",
    transform: "translate(173.061 -108.736)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M105.967,439.6c-1.693.13-2.735,1.172-4.167,3.125a21.9,21.9,0,0,1,5.73,7.292c1.042-1.3,2.214-1.953,4.688-2.6a22.452,22.452,0,0,0-6.251-7.817Z",
    transform: "translate(232.955 -108.675)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M-107.8,446.686a6.869,6.869,0,0,0,2.214-2.084,3.122,3.122,0,0,0-1.3-1.3,5.682,5.682,0,0,1-2.214,2.083C-108.319,445.644-107.928,445.9-107.8,446.686Z",
    transform: "translate(169.223 -107.557)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M-91.9,339.737c2.214,1.953,4.167,3.386,6.641,3.776a7.014,7.014,0,0,0,2.214-4.037,12.721,12.721,0,0,1-6.511-3.776C-89.816,337.653-90.337,338.825-91.9,339.737Z",
    transform: "translate(174.421 -140.073)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M65.783,511.623a5.325,5.325,0,0,0,2.865-4.558c-1.563-1.693-2.865-2.6-4.558-2.865-1.563,1.823-3.255,2.474-5.99,3.386a20.818,20.818,0,0,1,7.683,4.037Z",
    transform: "translate(219.749 -89.154)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M-60,500.244a2.476,2.476,0,0,0,1.3,2.083,3.411,3.411,0,0,0,2.083-1.3,6.149,6.149,0,0,1-.26-3.125A7.937,7.937,0,0,1-60,500.244Z",
    transform: "translate(184.061 -91.057)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M61.676,361.444a11.2,11.2,0,0,1-2.6-2.344,4.072,4.072,0,0,0-1.172,1.432,14.5,14.5,0,0,0,2.474,2.6C60.635,362.1,60.9,361.7,61.676,361.444Z",
    transform: "translate(219.688 -133.001)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M25.342,515.386a3.066,3.066,0,0,0,1.042-.261A9.779,9.779,0,0,1,25.212,512c-.391.13-.521.26-.912.13a7.934,7.934,0,0,0,1.042,3.256Z",
    transform: "translate(209.535 -86.797)",
    fill: "#40ffa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M-27.956,327.576c0-.781.391-1.563,1.693-3a3.755,3.755,0,0,0-2.474-.781,6.869,6.869,0,0,0-1.563,3.256,5.1,5.1,0,0,1,2.344.525Z",
    transform: "translate(193.035 -143.669)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M21.406,498.737a5.47,5.47,0,0,0-1.953-4.037,40.317,40.317,0,0,1-7.553,1.953,4.7,4.7,0,0,1,.651,2.474,22.587,22.587,0,0,1,8.855-.39Z",
    transform: "translate(205.787 -92.024)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M-81.01,456.814a4.611,4.611,0,0,0-3.776-2.214A6.771,6.771,0,0,0-87,458.376c1.432,1.172,2.084,2.474,2.865,4.688A17.643,17.643,0,0,1-81.01,456.814Z",
    transform: "translate(175.901 -104.142)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M-20.14,505.107a17.019,17.019,0,0,1,6.771.391,5.4,5.4,0,0,0-.13-3.516,23.916,23.916,0,0,0-6.9-.781C-19.619,502.893-19.358,503.935-20.14,505.107Z",
    transform: "translate(196.027 -90.06)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M52.414,327.5a4.844,4.844,0,0,1-2.214,2.344,15.772,15.772,0,0,0,4.688,2.214,8.251,8.251,0,0,0,1.172-2.865C54.888,329.193,53.976,328.542,52.414,327.5Z",
    transform: "translate(217.361 -142.551)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M-19.486,324.474A10.919,10.919,0,0,0-20.658,322a2.809,2.809,0,0,0-1.042,1.3,2.548,2.548,0,0,1,.781,1.563,1.55,1.55,0,0,1,1.433-.389Z",
    transform: "translate(195.635 -144.213)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M82.19,374.8a9.6,9.6,0,0,0-5.6,3.255,19.548,19.548,0,0,1-.391,4.688c1.3-.781,2.344-.521,4.3.521C80.5,380.53,81.148,378.186,82.19,374.8Z",
    transform: "translate(225.219 -128.257)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M34.657,339.809a4.31,4.31,0,0,0,.781-3,26.222,26.222,0,0,1-9.766-2.214,4.658,4.658,0,0,1-1.172,2.735,25.92,25.92,0,0,0,10.157,2.474Z",
    transform: "translate(209.596 -140.405)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M15.422,516.537a4.856,4.856,0,0,1-3.255-4.037C10.214,514.193,9.3,515.755,8,518.75c.521,1.823,1.3,2.474,3.255,3.255C12.3,519.532,13.339,517.839,15.422,516.537Z",
    transform: "translate(204.609 -86.646)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M65.953,373.474c.13-.651.391-.912,1.172-1.3A7.026,7.026,0,0,0,64.912,371,1.442,1.442,0,0,0,64,372.172a8.427,8.427,0,0,1,1.953,1.3Z",
    transform: "translate(221.532 -129.405)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M-32.07,512.181a2.608,2.608,0,0,1-.13,2.734,7.552,7.552,0,0,0,3.776-1.042,2.429,2.429,0,0,0-.13-2.474A5.615,5.615,0,0,1-32.07,512.181Z",
    transform: "translate(192.461 -86.978)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M-38.186,329.723c1.3-2.6,2.214-3.907,4.3-5.209a2.9,2.9,0,0,1-1.3-2.214,12.5,12.5,0,0,0-5.209,5.469,5.259,5.259,0,0,0,2.209,1.954Z",
    transform: "translate(189.983 -144.122)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M-108.989,425.7a12.961,12.961,0,0,1,4.688.912,36.733,36.733,0,0,1,.13-9.376,6.548,6.548,0,0,0-4.3-1.432,43.227,43.227,0,0,0-.518,9.9Z",
    transform: "translate(169.242 -115.867)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M8.881,512.414c.521-.391,1.3-.521,2.865-.26A3.875,3.875,0,0,0,11.1,510.2a5.854,5.854,0,0,0-3,.521,2.321,2.321,0,0,1,.781,1.693Z",
    transform: "translate(204.64 -87.341)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M-3.824,501.667a8.3,8.3,0,0,0-1.3-4.167,3.525,3.525,0,0,0-2.474.781,6.39,6.39,0,0,1,1.172,4.037,2.793,2.793,0,0,1,2.6-.651Z",
    transform: "translate(199.895 -91.178)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M69.3,481.021a1.961,1.961,0,0,0-1.042-.521,10.544,10.544,0,0,1-1.563,3.255,2,2,0,0,1,.912.651,9.207,9.207,0,0,0,1.693-3.385Z",
    transform: "translate(222.348 -96.316)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M-40.407,497.6a4.6,4.6,0,0,0-1.693,1.823,4.415,4.415,0,0,1,2.084,1.563,4.967,4.967,0,0,0,1.823-1.432,7.724,7.724,0,0,1-2.214-1.954Z",
    transform: "translate(189.469 -91.148)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M62.684,460.8a2.939,2.939,0,0,1-2.084.26,10.591,10.591,0,0,0,1.3,3.125,4.013,4.013,0,0,0,1.823-.911A4.877,4.877,0,0,1,62.684,460.8Z",
    transform: "translate(220.505 -102.269)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M-100.249,372.86a3.632,3.632,0,0,1-.651,2.735,2.869,2.869,0,0,0,2.083,0,5.983,5.983,0,0,0,.391-3A2.139,2.139,0,0,1-100.249,372.86Z",
    transform: "translate(171.701 -128.922)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M-55.6,488.043a6.04,6.04,0,0,1,.521,2.474,1.93,1.93,0,0,1,.912.13,6.737,6.737,0,0,0-.26-2.735,1.634,1.634,0,0,0-1.173.131Z",
    transform: "translate(185.39 -94.092)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M-43.314,499.672a2.3,2.3,0,0,0-1.042-1.172,14.08,14.08,0,0,1-2.344,1.432,2.726,2.726,0,0,1,.521.781,10.759,10.759,0,0,1,2.865-1.041Z",
    transform: "translate(188.08 -90.876)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M24.851,496.2c2.865.13,5.209,0,7.292-1.172a6.1,6.1,0,0,0-.781-4.427,12.426,12.426,0,0,1-7.162,1.042C25.112,493.335,25.5,494.507,24.851,496.2Z",
    transform: "translate(209.505 -93.263)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M41.32,477.153a7.084,7.084,0,0,1,4.037,0,1.778,1.778,0,0,1,.521-1.432,8.232,8.232,0,0,0-4.427-.391,2.987,2.987,0,0,0-.131,1.823Z",
    transform: "translate(214.652 -97.917)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M-43.656,304.493a3.066,3.066,0,0,0-.651-1.693,3.63,3.63,0,0,1-1.693.912,4.01,4.01,0,0,0,.391,1.693,8.976,8.976,0,0,1,1.953-.912Z",
    transform: "translate(188.291 -150.015)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M76.325,336.2a5.024,5.024,0,0,0-2.865,1.432,14.346,14.346,0,0,1-.26,2.344c.651-.391,1.172-.26,2.084.391a14.941,14.941,0,0,1,1.041-4.167Z",
    transform: "translate(224.312 -139.922)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M-80,476.553a6.551,6.551,0,0,0,1.3,3.646,7.751,7.751,0,0,1,3.776-1.823,9.63,9.63,0,0,0-.651-3.776A10.5,10.5,0,0,1-80,476.553Z",
    transform: "translate(178.017 -98.099)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M35.1,321.3a1.875,1.875,0,0,1-.781-1.3,12.766,12.766,0,0,0-3.516,2.344,3.213,3.213,0,0,0,.912,1.563A9.463,9.463,0,0,1,35.1,321.3Z",
    transform: "translate(211.499 -144.817)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M-116.839,432.292a2.457,2.457,0,0,0-2.474-.781,3.935,3.935,0,0,0-.781,2.474,4.867,4.867,0,0,1,2.214,2.344,8.458,8.458,0,0,1,1.041-4.037Z",
    transform: "translate(165.893 -111.133)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M86.534,432.211a3.379,3.379,0,0,1,1.563-2.735,29.477,29.477,0,0,0-7.943-3.776,8.561,8.561,0,0,0-1.953,3.386C81.586,429.346,83.669,430.388,86.534,432.211Z",
    transform: "translate(225.823 -112.876)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M8.591,494.291a3.432,3.432,0,0,1-.391,2.344,2.987,2.987,0,0,0,1.823-.13,5.947,5.947,0,0,0,.26-2.6,2.71,2.71,0,0,1-1.692.386Z",
    transform: "translate(204.67 -92.266)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M-58.193,493.558a2.913,2.913,0,0,0,.651-2.474A22.5,22.5,0,0,1-61.449,489a2.43,2.43,0,0,1-.651,1.3,18.548,18.548,0,0,1,3.907,3.258Z",
    transform: "translate(183.426 -93.747)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M-85.6,358.421a3.174,3.174,0,0,1,0,1.563,10.363,10.363,0,0,1,3.125-.521,3.574,3.574,0,0,0,.26-1.563A13.356,13.356,0,0,0-85.6,358.421Z",
    transform: "translate(176.324 -133.364)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M0,503.912a4.306,4.306,0,0,1,1.953,1.3.942.942,0,0,1,.781-.521A4.607,4.607,0,0,0,.651,503a3.954,3.954,0,0,0-.651.912Z",
    transform: "translate(202.191 -89.516)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M-88.768,364.7a19.408,19.408,0,0,0-7.032,1.172,7.855,7.855,0,0,0,2.474,3.516,6.586,6.586,0,0,1,4.3-.781A4.588,4.588,0,0,1-88.768,364.7Z",
    transform: "translate(173.241 -131.309)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M-45.422,498.876a3.88,3.88,0,0,1-.912-3.776c-1.953.521-3,1.3-4.948,2.865-.26,1.432.13,2.083,1.042,3.386a9.052,9.052,0,0,1,4.818-2.475Z",
    transform: "translate(186.671 -91.904)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M50.567,478.2a3.834,3.834,0,0,0-2.344-1.3,4.567,4.567,0,0,1-1.823.781c.521.26.651.781.781,1.693a7.988,7.988,0,0,1,3.386-1.174Z",
    transform: "translate(216.213 -97.404)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M-75.682,486a11.79,11.79,0,0,0-4.818,4.948,15.2,15.2,0,0,1,1.042,4.818c1.172-1.172,2.214-1.3,4.558-.781C-75.812,492.381-75.812,489.646-75.682,486Z",
    transform: "translate(177.865 -94.654)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M-66.775,501.5a7.552,7.552,0,0,0-3.125,1.953,3.291,3.291,0,0,0,1.823,1.172,3.322,3.322,0,0,1,1.953-1.172,1.95,1.95,0,0,1-.651-1.953Z",
    transform: "translate(181.069 -89.97)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M7.584,525.4A6.314,6.314,0,0,0,5.5,530.479a45.659,45.659,0,0,1,7.683,5.469,6.312,6.312,0,0,1,1.693-2.474A32.84,32.84,0,0,1,7.584,525.4Z",
    transform: "translate(203.854 -82.747)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M-79.571,378a6.737,6.737,0,0,0-5.079-2.6,39.375,39.375,0,0,1-6.251,7.683,5.671,5.671,0,0,1,2.474,1.953A42.106,42.106,0,0,1-79.571,378Z",
    transform: "translate(174.723 -128.076)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M74.613,358.641c-1.432-.911-2.6-2.474-3.516-6.641a9.416,9.416,0,0,0-4.3,3.646,15.923,15.923,0,0,0,4.3,6.771C71.879,360.725,72.79,359.943,74.613,358.641Z",
    transform: "translate(222.378 -135.147)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M-82.858,515.3a2.088,2.088,0,0,0,.13,1.953,24.3,24.3,0,0,1,3.255.521,2.238,2.238,0,0,1,.13-1.042,16.613,16.613,0,0,1-3.515-1.432Z",
    transform: "translate(177.098 -85.799)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M-21.019,515.346c.781-.391,1.693-.521,3.646.13a4.3,4.3,0,0,0-.521-2.735,7.892,7.892,0,0,0-3.907.13,4.646,4.646,0,0,1,.782,2.475Z",
    transform: "translate(195.604 -86.627)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M23.169,523a9,9,0,0,1-5.469,2.865c2.474,3.255,5.209,6.251,6.9,7.162a14.476,14.476,0,0,0,3.907-4.428C26.555,527.557,25.253,525.865,23.169,523Z",
    transform: "translate(207.54 -83.472)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M71.386,454.644a7.569,7.569,0,0,1-2.214-2.344A3.693,3.693,0,0,0,68,453.6a11.737,11.737,0,0,0,2.214,2.6C70.474,455.3,70.735,454.9,71.386,454.644Z",
    transform: "translate(222.74 -104.837)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M42.7,496.493c-.781-1.172-1.953-1.563-3.907-1.693a17.5,17.5,0,0,1-3,7.162,6.445,6.445,0,0,1,3.776,2.214,19.964,19.964,0,0,0,3.131-7.683Z",
    transform: "translate(213.011 -91.994)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M-54.8,333.2a3.9,3.9,0,0,0-.391,2.344,3.052,3.052,0,0,0,1.432.26,3.616,3.616,0,0,1,.391-2.344C-54.017,333.591-54.407,333.591-54.8,333.2Z",
    transform: "translate(185.499 -140.828)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M66.9,442.953a12.528,12.528,0,0,1,3,3.907,4.868,4.868,0,0,0,1.953-1.693A18.414,18.414,0,0,0,68.984,441C68.463,442.172,68.072,442.823,66.9,442.953Z",
    transform: "translate(222.408 -108.252)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M78.853,455.1c.26,1.3-.13,2.735-1.953,5.339a6.605,6.605,0,0,0,4.3.521,13.768,13.768,0,0,0,1.693-5.86,8.444,8.444,0,0,1-4.04,0Z",
    transform: "translate(225.43 -103.991)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M-85.226,367.1a8.294,8.294,0,0,0-.651,4.558,3.421,3.421,0,0,0,2.735.26,7.846,7.846,0,0,1,.651-4.558,2.531,2.531,0,0,1-2.735-.26Z",
    transform: "translate(176.21 -130.584)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M67.878,409.471a10.871,10.871,0,0,1,4.558.13,30.7,30.7,0,0,1-1.3-9.115,6.134,6.134,0,0,0-4.427-.651,37.28,37.28,0,0,0,1.169,9.636Z",
    transform: "translate(222.342 -120.737)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M100.1,409.293c2.214,1.823,3.255,2.865,4.167,5.079a3,3,0,0,1,2.344-.781c-.781-2.474-1.953-3.907-4.037-5.99a5.615,5.615,0,0,0-2.474,1.692Z",
    transform: "translate(232.441 -118.345)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M89.307,425.275a12.023,12.023,0,0,0-.13-6.12,6.111,6.111,0,0,0-3.776.13,9.426,9.426,0,0,1,0,5.99C87.093,424.624,88.135,424.494,89.307,425.275Z",
    transform: "translate(227.998 -114.925)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M-126.577,405.9c0,.912-.391,1.823-1.823,3.516a4.952,4.952,0,0,0,2.865.781,8.752,8.752,0,0,0,1.693-3.906A5.193,5.193,0,0,1-126.577,405.9Z",
    transform: "translate(163.391 -118.859)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M-88.014,481.9c-1.563.521-2.474,1.563-3.386,3.646a18.505,18.505,0,0,1,6.641,5.99c.781-1.432,1.693-2.214,3.907-3.386a20.932,20.932,0,0,0-7.162-6.25Z",
    transform: "translate(174.572 -95.893)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M-92.479,385.772A8.565,8.565,0,0,1-93,389.288a27.293,27.293,0,0,1,7.162-.26,4.809,4.809,0,0,0,.912-3.386,29.866,29.866,0,0,0-7.553.13Z",
    transform: "translate(174.088 -125.036)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M77,418.284a18.061,18.061,0,0,0,4.818,3.776,7.076,7.076,0,0,0,.781-3.646,6.036,6.036,0,0,1-3-2.214A3.837,3.837,0,0,1,77,418.284Z",
    transform: "translate(225.46 -115.747)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M74.5,473.511a5.4,5.4,0,0,0,1.432,3,2.73,2.73,0,0,0,1.823-.911,5.2,5.2,0,0,1-1.3-3,1.91,1.91,0,0,1-1.955.911Z",
    transform: "translate(224.705 -98.703)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M-110.747,415.965a8.9,8.9,0,0,1-3-2.865,31.282,31.282,0,0,1-4.558,7.032,5.769,5.769,0,0,0,2.6,3.125,42.775,42.775,0,0,0,4.958-7.292Z",
    transform: "translate(166.442 -116.683)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M22.081,494.684a6.264,6.264,0,0,1,2.084-1.042,1.789,1.789,0,0,0-.651-1.042,5.5,5.5,0,0,0-2.214,1.042A.99.99,0,0,1,22.081,494.684Z",
    transform: "translate(208.629 -92.659)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M35.325,490.112a6.192,6.192,0,0,1-2.735-.912,2.968,2.968,0,0,0-.391,1.432,14.221,14.221,0,0,0,2.735,1.172C34.8,491.023,34.8,490.632,35.325,490.112Z",
    transform: "translate(211.922 -93.687)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M-109.5,410.367a4.5,4.5,0,0,1,2.6-.26,10.357,10.357,0,0,0-1.563-3.907,7.22,7.22,0,0,0-2.344,1.042,5.323,5.323,0,0,1,1.307,3.125Z",
    transform: "translate(168.709 -118.768)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M-72.477,352.972a1.368,1.368,0,0,0-.651-1.172,2.518,2.518,0,0,0-1.172.651,3.606,3.606,0,0,1,.13,1.693,3.966,3.966,0,0,1,1.693-1.172Z",
    transform: "translate(179.739 -135.207)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M4.344,325.323A6.333,6.333,0,0,1,2.912,323.5a3.043,3.043,0,0,0-.912.912,7.216,7.216,0,0,0,1.432,1.953C3.693,325.583,3.823,325.323,4.344,325.323Z",
    transform: "translate(202.796 -143.76)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M83.606,408.446a4.822,4.822,0,0,0,1.042,3.255c2.735-1.693,6.251-2.735,10.287-3.646a5.254,5.254,0,0,1-.521-3.255A28.016,28.016,0,0,0,83.606,408.446Z",
    transform: "translate(227.449 -119.191)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M48.063,510.616a10.9,10.9,0,0,0,2.083-3.125A5.5,5.5,0,0,0,47.8,507.1a3.089,3.089,0,0,1-1.3,1.953,2.626,2.626,0,0,1,1.563,1.563Z",
    transform: "translate(216.243 -88.277)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M-64.915,491.064c1.432-.911,1.953-2.344,2.214-4.558a20.528,20.528,0,0,1-8.334-3.906c-.26,1.693-1.042,2.735-2.865,4.427a22.675,22.675,0,0,0,8.985,4.037Z",
    transform: "translate(179.86 -95.681)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M-65.5,319.509c1.823,0,3.516.651,6.641,3.516a9.027,9.027,0,0,0,1.432-5.469,16.476,16.476,0,0,0-7.422-3.255C-64.328,316.253-64.719,317.425-65.5,319.509Z",
    transform: "translate(182.398 -146.54)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M78.6,364.523a11.661,11.661,0,0,0,3.907,1.042,3.915,3.915,0,0,0-.521-2.344,4.07,4.07,0,0,1-2.344-.521,2.636,2.636,0,0,1-1.042,1.823Z",
    transform: "translate(225.944 -131.914)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M62.516,352.663a3.137,3.137,0,0,0-1.823-1.563,4.01,4.01,0,0,1-1.693.391,1.537,1.537,0,0,1,.391,1.563A7.614,7.614,0,0,1,62.516,352.663Z",
    transform: "translate(220.021 -135.419)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M-50.5,507.395a2.192,2.192,0,0,0,1.823,1.042,3.308,3.308,0,0,0,1.042-1.823,5.445,5.445,0,0,1-1.432-2.214A9.068,9.068,0,0,1-50.5,507.395Z",
    transform: "translate(186.931 -89.093)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M89.6,442.136a2.907,2.907,0,0,1,.4-1.823,10.178,10.178,0,0,0-3,.13,4.746,4.746,0,0,0,.26,1.823,4.478,4.478,0,0,1,2.34-.13Z",
    transform: "translate(228.482 -108.476)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M38.53,486.913a4.749,4.749,0,0,0,1.432-3.907,31.625,31.625,0,0,1-5.99-3.907,4.558,4.558,0,0,1-1.172,1.953,30.533,30.533,0,0,1,5.73,5.861Z",
    transform: "translate(212.104 -96.739)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M72.2,462.812a2.437,2.437,0,0,0,.651,1.823,4.014,4.014,0,0,1,1.823-.912,8.794,8.794,0,0,0-.26-1.823A4.726,4.726,0,0,1,72.2,462.812Z",
    transform: "translate(224.01 -101.936)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M-94.447,453.087a6.385,6.385,0,0,0,1.042-3.255,2.374,2.374,0,0,0-1.953-.521,5.3,5.3,0,0,1-1.042,3.125A2.392,2.392,0,0,1-94.447,453.087Z",
    transform: "translate(173.061 -105.755)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M-100.719,489.025a10.182,10.182,0,0,0,2.865-2.084,4.117,4.117,0,0,0-1.953-1.042,3.494,3.494,0,0,1-1.693,1.3A2.285,2.285,0,0,1-100.719,489.025Z",
    transform: "translate(171.52 -94.684)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M-103.3,452.063c.912,2.735,1.172,4.167.651,6.641a3.511,3.511,0,0,1,2.474.651,14.4,14.4,0,0,0-.13-7.422,5.79,5.79,0,0,0-2.995.13Z",
    transform: "translate(170.976 -104.991)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M-47.837,514.62a18.367,18.367,0,0,0,5.469-4.167,8.749,8.749,0,0,0-3.776-1.953,6.626,6.626,0,0,1-3.255,2.6,4.242,4.242,0,0,1,1.562,3.52Z",
    transform: "translate(187.264 -87.854)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M6.163,504.2A6.464,6.464,0,0,1,4.6,507.325a28.218,28.218,0,0,1,6.771,1.823,4.386,4.386,0,0,0,1.823-2.865A39.528,39.528,0,0,0,6.163,504.2Z",
    transform: "translate(203.582 -89.154)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M-107,350.663a2.781,2.781,0,0,1,.521,2.865,10.016,10.016,0,0,0,3.646-1.953,2.555,2.555,0,0,0-.651-2.474A5.724,5.724,0,0,1-107,350.663Z",
    transform: "translate(169.857 -136.023)",
    fill: "#ffd240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M-58.17,484.141c-.912-1.172-1.432-2.865-1.042-6.641a8.117,8.117,0,0,0-4.688,1.953,14.4,14.4,0,0,0,1.693,7.032,6.367,6.367,0,0,1,4.037-2.344Z",
    transform: "translate(182.882 -97.222)",
    fill: "#ffd240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Positive_Feedback",
    "data-name": "Positive Feedback",
    transform: "translate(68.4 176.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 110.25,
    cy: 110.25,
    r: 110.25,
    transform: "translate(8.6 8.61)",
    fill: "#4fcf5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M137.164,160.24a14.188,14.188,0,0,1-10.059-4.181L93.418,122.375a14.224,14.224,0,1,1,20.115-20.115l23.642,23.646,48.173-48.176a14.224,14.224,0,0,1,20.115,20.115L147.218,156.06A14.172,14.172,0,0,1,137.164,160.24Z",
    transform: "translate(-30.652 2.047)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccessfully);
export default __webpack_public_path__ + "static/media/order-successfully.5b6cbd366080eff1e01b239038c89b7e.svg";
export { ForwardRef as ReactComponent };